import styled from 'styled-components';
import { IGamesTabsWrap } from './types';

export const GamesTabsWrap = styled.div.withConfig({
  shouldForwardProp: (prop) => !['display'].includes(prop),
})<IGamesTabsWrap>`
  display: ${(props) => props.display === 'false' && 'none'};
`;
